module.exports = [
    '$scope',
    '$rootScope',
    '$location',
    'DataExport',
    'Notify',
    'FormEndpoint',
    'FormAttributeEndpoint',
    '_',
    'LoadingProgress',
    'Features',
    'UserSettingsEndpoint',
function (
    $scope,
    $rootScope,
    $location,
    DataExport,
    Notify,
    FormEndpoint,
    FormAttributeEndpoint,
    _,
    LoadingProgress,
    Features,
    UserSettingsEndpoint
) {
    $scope.exportAll = exportAll;
    $scope.showFields = false;
    $scope.showProgress = false;
    $scope.selectFields = selectFields;
    $scope.selectedFields = [];
    $scope.exportSelected = exportSelected;
    $scope.selectAll = selectAll;
    $scope.displayedForms = [];
    $scope.getForms = getForms;
    $scope.isLoading = LoadingProgress.getLoadingState;
    $scope.attachAttributes = attachAttributes;
    $scope.loadExportJobs = loadExportJobs;
    $scope.switchTab = switchTab;
    $scope.exportJobs = [];
    $scope.dataExportTitle =  'data_export.title';
    $scope.loadingFeature = true;

    $rootScope.$on('event:export_job:stopped', function () {
        $scope.showProgress = false;
    });
    $rootScope.$on('event:export_job:started', function () {
        $scope.showProgress = true;
    });

    // Redirect to home if not authorized
    if ($rootScope.hasPermission('Bulk Data Import and Export') === false && $rootScope.hasPermission('Bulk Data Import') === false) {
        return $location.path('/');
    }

    // Check if hxl-feature is enabled
    Features.loadFeatures().then(function () {
        $scope.hxlEnabled = Features.isFeatureEnabled('hxl');
        if ($scope.hxlEnabled) {
            $scope.dataExportTitle = 'data_export.title_hxl';
            $scope.loadingFeature = false;
        }
    });

    // Check if hxl-api-key is added
    UserSettingsEndpoint.getFresh({id: $rootScope.currentUser.userId}).$promise.then((settings) => {
        $scope.hxlApiKey = false;
        _.each(settings.results, (setting) => {
            if (setting.config_key === 'hdx_api_key') {
                $scope.hxlApiKey = true;
                $scope.loadingFeature = false;
            }
        });
    });

    // Change layout class
    $rootScope.setLayout('layout-c');
    // Change mode
    $scope.$emit('event:mode:change', 'settings');



    activate();

    function activate() {
        $scope.loadExportJobs();
        $scope.tab_history = {};

        // Set initial menu tab
        $scope.switchTab('export', 'main');
    }

    function getForms() {
        FormEndpoint.queryFresh().$promise.then(function (response) {
            $scope.forms = response;
            $scope.attachAttributes();
        });
    }

    function switchTab(section, tab) {

        // First unset last active tab
        var old_tab = $scope.tab_history[section];
        if (old_tab) {
            var old_tab_li = old_tab + '-li';
            angular.element(document.getElementById(old_tab)).removeClass('active');
            angular.element(document.getElementById(old_tab_li)).removeClass('active');
        }
        // Set new active tab
        tab = tab + '-' + section;
        $scope.tab_history[section] = tab;
        var tab_li = tab + '-li';
        angular.element(document.getElementById(tab)).addClass('active');
        angular.element(document.getElementById(tab_li)).addClass('active');
    }


    function attachAttributes() {
        // requesting attributes and attaches them to the correct form
        _.each($scope.forms, function (form) {
            FormAttributeEndpoint.query({formId: form.id}).$promise.then(function (response) {
                form.attributes = response;
            });
        });
    }

    function selectFields() {
        $scope.showFields = !$scope.showFields;
    }

    function selectAll(form) {
        $scope.selectedFields[form.id] = !$scope.selectedFields[form.id] ? [] : $scope.selectedFields[form.id];
        if ($scope.selectedFields[form.id].length === form.attributes.length) {
            $scope.selectedFields[form.id] = [];
        } else {
            _.each(form.attributes, function (attribute) {
                if (!_.contains($scope.selectedFields[form.id], attribute.key)) {
                    $scope.selectedFields[form.id].push(attribute.key);
                }
            });
        }
    }

    function exportAll() {
        DataExport.startExport({send_to_hdx: false, include_hxl: false, send_to_browser: true});
        $scope.showProgress = true;
    }

    function exportSelected() {
        var fields = _.chain($scope.selectedFields)
            .flatten() // concatinating attributes into one array
            .compact() // removing nulls
            .value(); // output

        if (fields.length === 0) {
            // displaying notification if no fields are selected
            var message =  '<p translate="data_export.no_fields"></p>';
            Notify.notifyAction(message, null, false, 'warning', 'error');
        } else {
            DataExport.startExport({fields, send_to_hdx: false, include_hxl: false, send_to_browser: true});
            $scope.showFields = false;
            $scope.showProgress = true;
        }
    }

    function loadExportJobs() {
        DataExport.loadExportJobs().then(function (response) {
            DataExport.setExportJobs(DataExport.processExportJobs(response));
            $scope.exportJobs = DataExport.getExportJobs();
        });
    }

    $scope.$on('exportJobs:updated', (event, data, newData) => {
        $scope.exportJobs = DataExport.getExportJobs();
    });


    // start fetching forms to display
    getForms();
}];
